import { IconProps } from './types'

export const DeleteIcon = ({ size, color }: IconProps) => {
  return (
    <svg
      width={size || '100%'}
      height={size || '100%'}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M17.8047 4.98503C15.0297 4.71003 12.238 4.56836 9.45469 4.56836C7.80469 4.56836 6.15469 4.65169 4.50469 4.81836L2.80469 4.98503"
        stroke={color || 'currentColor'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.39062 4.14297L7.57396 3.0513C7.70729 2.25964 7.80729 1.66797 9.21562 1.66797H11.399C12.8073 1.66797 12.9156 2.29297 13.0406 3.05964L13.224 4.14297"
        stroke={color || 'currentColor'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9771 18.3339H7.62708C5.30208 18.3339 5.22708 17.3172 5.13542 16.0089L4.59375 7.61719"
        stroke={color || 'currentColor'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0104 7.61719L15.4688 16.0089"
        stroke={color || 'currentColor'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
